import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import EmploymentHistoryOutputComponent from '../output/EmploymentHistoryOutputComponent';

const EmploymentHistoryInputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-briefcase', title: 'Employment History', subtitle: 'Fetch employment history by mobile number, with optional PAN/UAN refinement' }}
        fields={[
            { name: 'mobileNumber', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true, required: false },
            { name: 'uan', label: 'UAN (optional)', icon: 'pi-id-card', placeholder: '12-digit UAN', maxLength: 12, inputMode: 'numeric', numeric: true, mono: true, required: false },
            { name: 'employeeName', label: 'Employee Name (optional)', icon: 'pi-user', placeholder: 'Enter employee name', maxLength: 100, autoCapitalize: 'words', required: false },
        ]}
        endpoint={{
            path: '/tartan/employment-history',
            bodyMapper: (v, sid, lid) => ({
                mobile: v.mobileNumber,
                ...(v.pan && { pan: v.pan }),
                ...(v.uan && { uan: v.uan }),
                ...(v.employeeName && { employee_name: v.employeeName.trim() }),
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="employment"
        submitLabel="Fetch Employment History"
        successSummary="Employment history fetched"
        errorSummary="Employment history fetch failed"
        confirmHeader="Confirm employment history fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={EmploymentHistoryOutputComponent}
    />
);

export default EmploymentHistoryInputComponent;
